import { WalletPaymentMethod } from './WalletPaymentMethod'

export class WalletPaymentMethodWithdrawal extends WalletPaymentMethod {
  constructor (o: IWalletPaymentMethodData) {
    super(o)
  }
}
